import React from 'react';

import { DialogActions, FormField, Label, TextButton } from '@zillow/constellation';

import type { Section } from '../../../../models';
import YesAndNo from '../../../Widgets/YesAndNo';
import { ONE_HUNDRED_YEAR_FLOODPLAIN } from '../../../../constants';
import InlineTooltip from '../../../Widgets/InlineTooltip';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function OneHundredYearFloodplain({ section, setSectionValues }: Props): JSX.Element {
  function onYesFloodplainClick(): void {
    setSectionValues({
      [ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN]: true,
    });
  }

  function onNoFloodplainClick(): void {
    setSectionValues({
      [ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN]: false,
    });
  }

  return (
    <>
      <FormField
        label={
          <Label size="lg">
            Is the property located in a{' '}
            <InlineTooltip
              tooltipBodyText={
                <>
                  A 100-year floodplain has a 1% chance of flooding in any given year.
                  <DialogActions>
                    <TextButton
                      as="a"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.fema.gov/flood-zones"
                    >
                      Learn more
                    </TextButton>
                  </DialogActions>
                </>
              }
              closeWith={['blur']}
              openWith={['focus', 'click', 'mouseEnter']}
              shouldCloseOnOutsideClick
            >
              100-year floodplain
            </InlineTooltip>
            ?
          </Label>
        }
        control={
          <YesAndNo
            noHandler={onNoFloodplainClick}
            yesHandler={onYesFloodplainClick}
            yesActive={section.getFieldValue(ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN)}
          />
        }
      />
    </>
  );
}

OneHundredYearFloodplain.description = 'Oregon specific flooding screen';
